import { app } from '../../app.module'
/**
 * ユーザー名パネルのディレクティブが呼び出された際に使用するサービス
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function userNamePanelService(Restangular, $q) {
  /**
   * ユーザー情報をDBから取得する
   * @return {Function} ユーザー情報をPromiseとしてリターン
   */
  function getUserData() {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()

    // DBからユーザー情報を取得
    Restangular.all('/users/getUserData')
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })
    // 結果をpromiseとしてリターン
    return deferred.promise
  }

  /**
   * ユーザー更新通知フラグをセットする
   * @param {Number} 更新通知フラグ
   * @return {Function} 保存結果
   */
  function saveUserNotificationFlg(userData) {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()

    // DBに更新通知フラグをセット
    Restangular.all('/users/saveUserNotificationFlg')
      .post(userData)
      .then((result) => {
        deferred.resolve(result)
      })
    // 結果をpromiseとしてリターン
    return deferred.promise
  }
  return {
    // ユーザー情報をDBから取得する
    getUserData: getUserData,
    saveUserNotificationFlg: saveUserNotificationFlg,
  }
}

// ユーザー名パネルのディレクティブを定義
app.factory('userNamePanelService', userNamePanelService)
